// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__liMiB","fileBtn":"File_fileBtn__UtAg9","closeBtn":"File_closeBtn__3iENp","fileSelected":"File_fileSelected__2Gnmt","disabled":"File_disabled__Mu8uu"};